import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

export const structMainSideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: 'remark' },
    ],
  },
];

export const structSubSideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '狀態', value: entityStatusSideMsgValue },
      {
        label: '主分類',
        value: (row) => row?.mtrStructMain?.name || row?.mtrStructMainId || '-',
      },
      { label: '備註', value: 'remark' },
    ],
  },
];
